import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import { useHistory }    from "react-router-dom"
import '../../App.css'
import '../../style.css';

function START_Button({ onClick }) {
  const history = useHistory()

  // STARTボタンクリック時の処理
  const handleClick = () => {
    onClick() // 親コンポーネントから渡された関数を呼び出す
  }

  return (
      <Box sx={{ m : 1 , p : 4}}>
        {/* STARTボタン */}
        <Box
          onClick={handleClick} // ボタンのクリックイベント  
          sx={{
            m: 1, // 外側の余白
            p: 1, // 内側の余白
            borderRadius   : "10px"     ,
            bgcolor        : '#000000'  ,
            height         : "1px"     ,
            width          : '35px'     ,
            position       : 'absolute' , // 絶対位置指定
            top            : '620px'    , // 縦位置を50pxに指定
            left           : '200px'    , // 横位置を20pxに指定
            display        : 'flex'     , // フレックスボックスを使用
            alignItems     : 'center'   , // 垂直方向の中央揃え
            justifyContent : 'center'   , // 水平方向の中央揃え
            color          : '#333631'  , // テキストカラーをグレーに設定
          }}>
        </Box>
        {/* START 表示 */}
        <Typography
            sx={{
              fontSize     : "10px"         , 
              bgcolor      : 'transparent'  ,
              color        : '#696969'      , // フォントの色を白に設定
              position     : 'absolute'     , // 絶対位置指定
              top          : '648px'        , // 縦位置を50pxに指定
              left         : '215px'        , // 横位置を20pxに指定
          }}>START</Typography>
      </Box>
  )
}

export default START_Button;
